<template>
    <FooterRenderer :slot-data="categoryPage.footer ?? undefined" />
</template>

<script setup lang="ts">
import FooterRenderer from '@/components/prismic/FooterRenderer.vue';
import { categoryPageStore } from '@/stores/category/CategoryPageStore';

const categoryPage = categoryPageStore();
</script>
